import Bugsnag from "@bugsnag/js";
import enhanceOptions from "../utils/enhanceOptions.js";
import mockBugsnag from "../utils/mockBugsnag.js";
import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const options = enhanceOptions(config.public.bugsnag);
  let client = Bugsnag;
  if (!Bugsnag.isStarted()) {
    try {
      client = Bugsnag.start(options);
    } catch (_error) {
      console.log("[Bugsnag] started in mock mode");
      return {
        provide: {
          bugsnag: mockBugsnag
        }
      };
    }
  }
  nuxtApp.vueApp.provide("bugsnag-client", client);
  const plugin = Bugsnag.getPlugin("vue");
  if (plugin !== void 0) {
    nuxtApp.vueApp.use(plugin);
  }
  return {
    provide: {
      bugsnag: client
    }
  };
});
